// ----
// Client StatsMaster
// Where we track all end-user actions like clicking on share tools, content panes, etc.
// ----


var SCM = SCM || {};

SCM.ClientStatsMaster = (function ($) {
    // ----
    // Private Functions and Variables go here
    // ----
    function UserTracking(sourceType, actionType, actionDescription, url, searchData, isTurnAway) {
        this.SourceType = sourceType;
        this.ActionType = actionType;
        this.ActionDescription = actionDescription;
        this.ActionUrl = url;
        this.SearchData = searchData;
        this.IsTurnaway = isTurnAway;
    }

    UserTracking.prototype.toJson = function () {
        return JSON.stringify(this);
    };


    function sendTrackingData(sourceType, actionType, actionDescription, url, searchData, isTurnAway) {
        var ucaData = new UserTracking(sourceType, actionType, actionDescription, url, searchData, isTurnAway).toJson();
        var serviceUrl = '/Services/UserActionService.svc/TrackUserAction';

        $.ajax({
            type: 'POST',
            url: serviceUrl,
            data: ucaData,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            async: true,
            processData: true
        })
        .fail(function (jqXhr, textStatus) {
            if (window.console) {
                console.error('jqXhr.responseText: ' + jqXhr.responseText);
                console.error('status: ' + textStatus);
            }
        });
    }

    // ----
    // Return an object exposed to the public
    // ----
    return {

        // Content Tabs
        trackContentTabEvents: function(){
            // set 1 click event on wrapper instead of individual click events on each item.
            var wrapperElem = $('#Toolbar');
            var trackedTabActions = {
                '#FigureTab': 'FiguresClicked',
                '#TableTab': 'TablesClicked',
                '#ContentTab': 'ArticleClicked',
                '#SupplementTab': 'SupplementClicked',
                '#MultimediaTab': 'MultimediaClicked'
            };

            wrapperElem.on('click', '.tab-trigger', function() {
                var tab = $(this).attr('data-tab');

                if (tab in trackedTabActions) {
                    sendTrackingData(22, 'View', trackedTabActions[tab], window.location.href, '', false);
                    //console.log(trackedTabActions[tab]);
                }
            });
        },


        // Shares
        trackShares: function (){
            var wrapperElem = $('#ShareDrop');
            var trackedShareActions = {
                'addthis_button_email': 'EmailClicked',
                'addthis_button_share': 'TwitterClicked',
                'addthis_button_facebook': 'FacebookClicked',
                'addthis_button_compact': 'CompactClicked',
            };

            wrapperElem.on('click', 'a', function() {
                // make this more robust so if people add class names it doesn't break
                var shareLink = $(this).attr('class');

                if (shareLink in trackedShareActions) {
                    sendTrackingData(22, 'Share', trackedShareActions[shareLink], window.location.href, '', false);
                    //console.log(trackedShareActions[shareLink]);
                }
            });
        },

        trackSingleAction: function($elem, actionType, actionDescription){
            $elem.on('click', function () { // GetCitation
                sendTrackingData(22, actionType, actionDescription, window.location.href, '', false);
            });
        }

    };

})(jQuery);


$(window).on('load', function(){
    SCM.ClientStatsMaster.trackContentTabEvents();
    SCM.ClientStatsMaster.trackShares();
    SCM.ClientStatsMaster.trackSingleAction($('a[data-reveal-id="getCitation"]'), 'Tools', 'GetCitationClicked');
    SCM.ClientStatsMaster.trackSingleAction($('div#getAlertsConfirmation'), 'Tools', 'AlertAdded');
    SCM.ClientStatsMaster.trackSingleAction($('#PermissionsLink'), 'Tools', 'GetPermissionsClicked');
    SCM.ClientStatsMaster.trackSingleAction($('a.tablelink').filter(':parent'), 'ViewLargeImage', 'ViewLargeImageClicked');
});